export const dataTestIds = {
	// Galería de productos
	'pdp.gallery.slideshow': 'pdp.gallery.slideshow',
	'pdp.gallery.grid': 'pdp.gallery.grid',
	'pdp.gallery.image': 'pdp.gallery.image',

	// Información del producto
	'pdp.productInfo.tags': 'pdp.productInfo.tags',
	'pdp.productInfo.title': 'pdp.productInfo.title',
	'pdp.productInfo.reference': 'pdp.productInfo.reference',
	'pdp.productInfo.price': 'pdp.productInfo.price',
	'pdp.productInfo.colorSelector': 'pdp.productInfo.colorSelector',
	'pdp.productInfo.colorSelector.label': 'pdp.productInfo.colorSelector.label',
	'pdp.productInfo.sizeSelector': 'pdp.productInfo.sizeSelector',
	'pdp.productInfo.sizeSelector.sizeAvailable':
		'pdp.productInfo.sizeSelector.sizeAvailable',
	'pdp.productInfo.sizeSelector.sizeUnavailable':
		'pdp.productInfo.sizeSelector.sizeUnavailable',
	'pdp.productInfo.addToBag': 'pdp.productInfo.addToBag',
	'pdp.productInfo.favorites': 'pdp.productInfo.favorites',

	// Product details
	'pdp.productDetails.description': 'pdp.productDetails.description',
	'pdp.productDetails.kcSafety': 'pdp.productDetails.kcSafety',
	'pdp.productDetails.breadcrumbs': 'pdp.productDetails.breadcrumbs',

	// Composition, origin, care
	'pdp.productDetails.compositionOriginAndCare':
		'pdp.productDetails.compositionOriginAndCare',
	'pdp.productDetails.compositionOriginAndCare.origin':
		'pdp.productDetails.compositionOriginAndCare.origin',
	'pdp.productDetails.compositionOriginAndCare.fabricationOrFinish':
		'pdp.productDetails.compositionOriginAndCare.fabricationOrFinish',
	'pdp.productDetails.compositionOriginAndCare.designed':
		'pdp.productDetails.compositionOriginAndCare.designed',
	'pdp.productDetails.compositionOriginAndCare.composition':
		'pdp.productDetails.compositionOriginAndCare.composition',
	'pdp.productDetails.compositionOriginAndCare.washingRules':
		'pdp.productDetails.compositionOriginAndCare.washingRules',
	'pdp.productDetails.compositionOriginAndCare.releasesMicrofibers':
		'pdp.productDetails.compositionOriginAndCare.releasesMicrofibers',
	'pdp.productDetails.compositionOriginAndCare.recyclability':
		'pdp.productDetails.compositionOriginAndCare.recyclability',

	// Cross selling
	'pdp.crossSelling.similars': 'pdp.crossSelling.similars',
	'pdp.crossSelling.totalLook': 'pdp.crossSelling.totalLook',
	'pdp.crossSelling.recommendations': 'pdp.crossSelling.recommendations',
	'pdp.crossSelling.lastViewed': 'pdp.crossSelling.lastViewed',
	'pdp.zoom.image': 'pdp.zoom.image',
	'pdp.zoom.thumbnails': 'pdp.zoom.thumbnails',

	// Unused but defined data-test id
	// 'pdp.gallery.video': 'pdp.gallery.video', // Videos
	// 'pdp.productInfo.delivery': 'pdp.productInfo.delivery', // Delivery
	// 'pdp.productInfo.availability': 'pdp.productInfo.availability', // Availability
	// 'pdp.productInfo.share': 'pdp.productInfo.share', // Share
	// 'pdp.sticky.price': 'pdp.sticky.price', // Pecio de la sticky
	// 'pdp.sticky.image': 'pdp.sticky.image', // Imagen de la sticky
	// 'pdp.sticky.title': 'pdp.sticky.title', // Title de la sticky
	// 'pdp.sticky.color': 'pdp.sticky.color', // Color de la sticky
	// 'pdp.sticky.size': 'pdp.sticky.size', // Talla de la sticky
	// 'pdp.sticky.addToBag': 'pdp.sticky.addToBag', // Add to bag de la sticky
	// 'pdp.sticky.favorites': 'pdp.sticky.favorites', // Favoritos de la sticky
}
